// extracted by mini-css-extract-plugin
export default {"button":"selectable-tile-section_button__67nPv"};